import type { OrganizationDto, VenueDto } from '@_/api-contracts/public-api.ts';
import { linkOptions } from '@tanstack/react-router';

export const LinkOptionsBuilder = {
  organization(options: {
    organization?:
      | Pick<OrganizationDto, 'id' | 'vanityName'>
      | { organizationId: string; vanityName: string | null };
    organizationId?: string;
    vanityName?: string;
  }) {
    const vanityName = options.vanityName || options.organization?.vanityName;
    const orgId =
      options.organizationId ||
      (options.organization && 'id' in options.organization
        ? options.organization.id
        : options.organization?.organizationId);

    if (vanityName) {
      return linkOptions({
        from: '/{-$locale}',
        to: '/{-$locale}/@{$vanityName}',
        params: prev => ({
          locale: prev.locale,
          vanityName
        })
      });
    } else if (orgId) {
      return linkOptions({
        from: '/{-$locale}',
        to: '/{-$locale}/organization/$orgId',
        params: prev => ({
          locale: prev.locale,
          orgId
        })
      });
    } else {
      throw new Error('Unable to resolve organization URL');
    }
  },

  venue(options: {
    venue?: Pick<VenueDto, 'id' | 'vanityName'>;
    vanityName?: string;
    venueId?: string;
  }) {
    const vanityName = options.vanityName || options.venue?.vanityName;
    const venueId = options.venueId || options.venue?.id;

    if (vanityName) {
      return linkOptions({
        from: '/{-$locale}',
        to: '/{-$locale}/@{$vanityName}',
        params: prev => ({
          locale: prev.locale,
          vanityName
        })
      });
    } else if (venueId) {
      return linkOptions({
        from: '/{-$locale}',
        to: '/{-$locale}/venue/$venueId',
        params: prev => ({
          locale: prev.locale,
          venueId
        })
      });
    } else {
      throw new Error('Unable to resolve venue URL');
    }
  }
};
